import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { WIZARD_STEP } from 'constants/wizardConstants';
import { getLanguage } from 'utils/cookies';

export const SetupGuide = ({ step }) => {
  const selectedObject = {};
  const language = getLanguage();
  switch (step) {
    case WIZARD_STEP.GUIDE_1:
      selectedObject.label = 'BTY_W_T_ADD_MEMBER';
      selectedObject.imgName = 'img_guide1';
      break;
    case WIZARD_STEP.GUIDE_2:
      selectedObject.label = 'BTY_W_T_QUICK_LINK_GUIDE';
      selectedObject.imgName = 'img_guide2';
      break;
    case WIZARD_STEP.GUIDE_3:
      selectedObject.label = 'BTY_W_T_APPROVAL_GUIDE';
      selectedObject.imgName = 'img_guide3';
      break;
    default:
      break;
  }

  return (
    <div>
      <div className="setup_Inbox">
        <Trans i18nKey={selectedObject.label} />
      </div>
      <div className={`guide_main_img ${selectedObject.imgName} ${language}`} />
    </div>
  );
};

SetupGuide.propTypes = { step: PropTypes.number.isRequired };
SetupGuide.defaultProps = {};
export default SetupGuide;
